// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2CLPH","footer":"styles_footer__1bF3U"};